module.exports = __webpack_public_path__ + "img/patient.fb7d9e8a.svg";